import { useToasts } from '@/hooks/Toasts/useToasts';
import mergeOperations from '@/util/shallowMerge';
import { useMutation } from '@apollo/client';
import { useMemo } from 'react';
import DEFAULT_OPERATIONS from './notifyForm.gql';

export default props => {
  const { selectedOptionsArray, variants, afterSubmit, product_id, setIsSubmitOk, productSku } = props;
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);
  const { addProductTipMutation } = operations;
  const [, { addToast }] = useToasts();

  const [addProductTip, { error, loading: isLoading }] = useMutation(addProductTipMutation, {
    onCompleted: data => {
      const response = data?.addProductTip;
      if (response && response.code === '200') {
        addToast({
          type: 'success',
          message: 'Your message has been sent.',
          timeout: 1000,
        });
        setIsSubmitOk(true);
      } else if (response) {
        addToast({
          type: 'error',
          message: response.content,
          timeout: 1000,
        });
      }
    },
  });

  const handleSubmit = async ({ email }) => {
    const selectedVariant = Array.isArray(variants)
      ? variants.find(temp => {
          return temp.attributes.every(x => selectedOptionsArray.some(selectedUid => selectedUid === x.uid));
        })
      : null;

    try {
      await addProductTip({
        variables: {
          product_id: product_id,
          sku: selectedVariant?.product?.sku || productSku,
          email,
        },
      });

      if (afterSubmit) {
        afterSubmit();
      }
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(error);
      }
    }
  };

  const errors = useMemo(() => new Map([['addProductTipError', error]]), [error]);

  return {
    isLoading,
    errors,
    handleSubmit,
  };
};
